function initCartDiscount() {
  var applyBtn = document.getElementById('cart-discount-apply');
  if (!applyBtn) return;
  
  // Prevent duplicate listeners
  if (applyBtn.dataset.discountInit) return;
  applyBtn.dataset.discountInit = 'true';

  applyBtn.addEventListener('click', function() {
    var code = document.getElementById('cart-discount-input').value.trim();
    var msg = document.getElementById('cart-discount-message');
    if (!code) return;
    fetch('/discount/' + encodeURIComponent(code), {
      method: 'GET',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function() {
      window.location.href = '/cart?discount=' + encodeURIComponent(code);
    }).catch(function() {
      msg.textContent = 'Unable to apply discount. Please try again.';
      msg.className = 'cart-discount__message error';
      msg.style.display = 'block';
    });
  });
}

// Try on DOM ready
document.addEventListener('DOMContentLoaded', initCartDiscount);

// Also watch for dynamic cart rendering
var observer = new MutationObserver(function() {
  initCartDiscount();
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});